// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'estimate.page.title': 'Estimates',
    'estimate.page.title.duplicate': 'Duplicate Estimate',
    'estimate.page.archive.title': 'Archived Estimates',
    'estimate.page.create.title': 'New Estimate',
    'estimate.page.search.title': 'Find Estimates',
    'estimate.page.convert.title': 'Convert to Invoice',
    'estimate.page.convert_to_proforma.title': 'Convert to Pro Forma Invoice',
    'estimate.page.edit.title': 'Edit Estimate',
    'estimate.page.edit.email': 'Email Estimate',

    'estimate.button.find': 'Find Estimates',
    'estimate.button.cancel': 'Cancel',
    'estimate.button.create': 'Save',
    'estimate.button.convert_to_invoice': 'Convert to Invoice',
    'estimate.button.convert_to_proforma': 'Convert to Pro Forma',
    'estimate.button.new': 'New Estimate',
    'estimate.button.cancel_invoice': 'Void Estimate',
    'estimate.button.mark_lost': 'Mark as Lost',
    'estimate.button.archive': 'Archive',
    'estimate.button.restore': 'Restore',
    'estimate.button.duplicate': 'Duplicate',

    'estimate.placeholder.search': 'Search estimates',

    'estimate.message.no_change': 'This estimate has not changed since it was created.',

    'estimate.link.create_first_estimate': 'Click here to create your first estimate',
    'estimate.link.estimates': ' Return to Estimates',
    'estimate.link.archive': 'Archived Estimates',

    'estimate.label.cancelled_estimate': 'Cancelled Estimate',
    'estimate.label.void_reason': 'Reason for voiding estimate',
    'estimate.label.estimate_number': 'Estimate No',
    'estimate.label.transaction_date': 'Estimate Date',
    'estimate.label.currency_name': 'Currency',

    'estimate.label.draft_estimate': 'Draft Estimate',
    'estimate.label.estimate': 'Estimate',

    'estimate.modal.title.estimate_cancel': 'Void Estimate',
    'estimate.modal.title.estimate_lost': 'Mark Estimate as Lost',
    'estimate.modal.title.estimate_archive': 'Archive Estimate',
    'estimate.modal.title.estimate_restore': 'Restore Estimate',

    'estimate.modal.message.estimate_cancel': 'Are you sure that you want to void this estimate? This action cannot be undone. | Are you sure that you want to void these estimates? This action cannot be undone.',
    'estimate.modal.message.estimate_lost': 'Are you sure that you want to mark this estimate as lost? This action cannot be undone.',
    'estimate.modal.message.estimate_archive': 'Are you sure that you want to move this estimate to the archive? | Are you sure that you want to move these estimates to the archive?',
    'estimate.modal.message.estimate_restore': 'Are you sure that you want to restore this estimate? | Are you sure that you want to restore these estimates?',

    'estimate.success.message.estimate_created': 'Your estimate has been created',
    'estimate.success.message.estimate_updated': 'Your estimate has been updated',
    'estimate.success.message.estimate_marked_lost': 'Your estimate has been marked as lost',
    'estimate.success.message.estimate_converted': 'Your estimate was successfully converted.',
    'estimate.success.message.archived_estimates': 'Your estimate was moved to the archive | All selected estimates were moved to the archive',
    'estimate.success.message.estimate_restored': 'Your estimate has been restored | All selected estimates were restored',

    'estimate.error.message.archived_estimates': 'This estimate was already moved to the archive | These estimates were already moved to the archive',
    'estimate.error.message.estimate_restored': 'This estimate was already restored | These estimates were already restored',
};
